import { useState, useEffect } from 'react';
import styles from './tripSettingsPage.module.css';
import { useParams, useNavigate} from 'react-router-dom';
import { API_URL } from '../utils/fatch';
import { DestinationAndCalendarCom } from '../newTrip/inputForm/dateAndDes';
import { useTripInfo } from '../context';




export function TripSettingsPage() {






    const navigate = useNavigate();


    const { setTrip_name, currentTripId, setCurrentTripStartDate, setCurrentTripEndDate } = useTripInfo();


    const [tripName, setTripName] = useState('');
    const [destination, setDestination] = useState('');

    const [fakeDate, setFakeDate] = useState(true);
    const [dateRange, setDateRange] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        },
    ]);
    const [country, setCountry] = useState(null);
    const [city, setCity] = useState(null);
    const [neighborhood, setNeighborhood] = useState(null);
    const [state, setState] = useState(null);
    const [error, setError] = useState();
    const [saveError, setSaveError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const locationProps = {

        setDestination,

        setCountry,

        setCity,

        setNeighborhood,

        setState,
        destination,
    };
    const { id } = useParams();


    const [budget, setBudget] = useState(0);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        if (!id) return; // guard against empty id

        const fetchTrip = async () => {
            try {
                setLoading(true);
                setError(null);

                // Await the fetch call
                const res = await fetch(`${API_URL}/tripTotalInfo/${id}`, {
                    method: 'GET',
                    credentials: 'include',
                }

                );
                if (!res.ok) {

                    throw new Error("Failed to fetch trip");
                }

                const data = await res.json();
                console.warn(data.trip.country);
                setTripName(data.trip.trip_name);
                setDestination(data.trip.destination)
                setBudget(Number(data.trip.budget));
                setCountry(data.trip.country);
                setCity(data.trip.city);
                setNeighborhood(data.trip.neighborhood);
                setState(data.trip.state);


                setDateRange([
                    {
                        startDate: new Date(data.trip.start_date),
                        endDate: new Date(data.trip.end_date),
                        key: 'selection',
                    },
                ]);
                setFakeDate(false);

            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchTrip();
    }, [id]);





    const handleSave = async (e) => {
        setSaveError(null);
        setIsSubmitting(true);
        e.preventDefault();
        const newTripData = {
            id,
            name: tripName,
            destination: destination,
            country,
            city,
            neighborhood,
            state,

            startDate: dateRange[0]?.startDate.toISOString().split('T')[0],
            endDate: dateRange[0]?.endDate.toISOString().split('T')[0],

            budget: budget,


        };


        try {
            const response = await fetch(`${API_URL}/update_trip`, {
                method: 'PUT',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(newTripData)
            });


            if (!response.ok) {
                const data = await response.json();
                console.error(data);
                setSaveError(data.message);

                return;
            }
         
     
            if (currentTripId === Number(id)) {

                setTrip_name(tripName);
               
                setCurrentTripStartDate( new Date(dateRange[0]?.startDate).toISOString());
                 setCurrentTripEndDate( new Date(dateRange[0]?.endDate).toISOString());
            }






         navigate(`/all_trips`);
        } catch (error) {
            console.error('Error adding new trip:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (loading) return <p>Loading trip...</p>;
    if (error) return <p>Error: {error}</p>;


    return (
        <form onSubmit={handleSave} className={styles.body}>
            <header className={styles.tripHeader} style={saveError ? { paddingBottom: '16px' } : { paddingBottom: '32px' }}>
                <h3 className={styles.tripTitle}>{tripName}</h3>
                <div className={styles.tripActions}>
                    <button type="button" className={`${styles.btn} ${styles.cancel}`} disabled={isSubmitting}>Cancel</button>
                    <button type='submit' className={`${styles.btn} ${styles.save}`} disabled={isSubmitting}>{isSubmitting ? 'Saving...' : 'Save Changes'}</button>
                </div>

            </header>
            <p style={{ fontSize: '14px', color: 'red', textAlign: 'end', paddingBottom: '16px' }}>{saveError}</p>

            <div className={styles.tripFormContainer}>
                <section className={styles.tripSection}>




                    <div className={styles.formGrid} style={{ marginBottom: '2rem' }}>

                        <div className={styles.formGroup} >
                            <label htmlFor="trip-name">Trip Name</label>
                            <input
                                id="trip-name"
                                className={styles.tripName}
                                value={tripName}
                                onChange={(e) => setTripName(e.target.value)}
                            />
                        </div>




                        <div className={`${styles.formGroup}`}>
                            <label>Total Budget</label>

                            <input type="number" value={budget} />


                        </div>
                    </div>












                    <DestinationAndCalendarCom type='update' setDateRange={setDateRange} dateRange={dateRange} {...locationProps} fakeDate={fakeDate} />







                </section>
            </div>
        </form>
    );
}
